<template>
  <div>
    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column prop="appType" label="系统" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.appType == 1">安卓</span>
            <span v-if="row.appType == 2">ios</span>
            <span v-if="row.appType == 3">网站</span>
          </template>
        </el-table-column>
        <el-table-column prop="isShopping" label="商城入口" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.isShopping == 1">开放</span>
            <span v-if="row.isShopping == 0">未开放</span>
            <el-button
              size="mini"
              style="margin: 0 0 10px 10px; padding: 5px 5px"
              type="success"
              v-if="row.isShopping == 0"
              @click="shopping(row, 1)"
              >开放</el-button
            >

            <el-button
              size="mini"
              style="margin: 0 0 10px 10px; padding: 5px 5px"
              type="warning"
              @click="shopping(row, 0)"
              v-if="row.isShopping == 1"
              >关闭</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="isAdvertisement"
          label="第三方广告"
          align="center"
        >
          <template slot-scope="{ row }">
            <span v-if="row.isAdvertisement == 1">开放</span>
            <span v-if="row.isAdvertisement == 0">未开放</span>
            <el-button
              size="mini"
              style="margin: 0 0 10px 10px; padding: 5px 5px"
              type="success"
              v-if="row.isAdvertisement == 0"
              @click="Advertisement(row, 1)"
              >开放</el-button
            >

            <el-button
              size="mini"
              style="margin: 0 0 10px 10px; padding: 5px 5px"
              type="warning"
              @click="Advertisement(row, 0)"
              v-if="row.isAdvertisement == 1"
              >关闭</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    getList() {
      this.getAxios("/app/sys/status").then((res) => {
        this.list = res.content;
      });
    },
    shopping(row, val) {
      this.getAxios("/app/update/sys/status", {
        appType: row.appType,
        isShopping: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    Advertisement(row, val) {
      this.getAxios("/app/update/sys/status", {
        appType: row.appType,
        isAdvertisement: val,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
